import { FC } from "react";
import { useParams } from "react-router-dom";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

// components
import HeadingSelect from './HeadingSelect';
import InlineStyleButtons from './InlineStyleButtons';
import BlockStyleButtons from './BlockStyleButtons';
import LinkButton from './LinkButton';
import LinkMediaPageButton from "./LinkMediaPageButton";
import MentionSelect from './MentionSelect';

// mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export const ToolbarPlugin: FC = () => {
    const [editor] = useLexicalComposerContext();
    const isEditable = editor.isEditable();
    const params = useParams();
    const topicId = params.topicId;

    if (!isEditable) return null;

    return (
        <Box sx={{ mb: 0.5, overflowX: "auto" }}>
            <Stack spacing={1} direction="row" pt="8.5px" pb={1.5}>
                <LinkMediaPageButton />
                <HeadingSelect />
                <InlineStyleButtons />
                {/*<ColorStyleButton editorState={editorState} setEditorState={setEditorState} />*/}
                <BlockStyleButtons />
                <LinkButton />
                {topicId &&
                    <MentionSelect />
                }
            </Stack>
        </Box>
    );
}